import { useTranslation } from 'react-i18next';
import { FavoriteOutlined as FavoriteOutlinedIcon } from '@vgno/icons';

import * as styles from './EmptyState.module.scss';

const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div>
        <FavoriteOutlinedIcon className={styles.icon} />
      </div>
      <div className={styles.title}>{t('you dont have favourites')}</div>
      <div className={styles.subtitle}>{t('your favourites will be here')}</div>
    </div>
  );
};

export { EmptyState };
